import styled from '@emotion/styled';
import React from 'react';
import { useI18NextContext } from '@components/hooks';
import { TestId } from '@components/test-ids';
import { getDayRange } from '@model/common/dates/get-day-range';

export interface TitleProps {
  dayNo: number;
  length: number;
}

const Container = styled.div();

export const Title = ({ dayNo, length }: TitleProps) => {
  const t: any = useI18NextContext();
  return (
    <Container data-testid={TestId.itinerary.title}>
      {t('common__label--day')} {getDayRange(dayNo, length)}
    </Container>
  );
};
